export enum StructureMemberState {
  WAITING_JOIN_ACCEPTED = 'WAITING_JOIN_ACCEPTED',
  WAITING_INVITE_ACCEPTED = 'WAITING_INVITE_ACCEPTED',
  ACCEPTED = 'ACCEPTED',
  WAITINT_LINK_ACCEPTED = 'WAITINT_LINK_ACCEPTED',
}
